import * as React from "react";
import "./Layout.css";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Sidebar from "../Sidebar/Index";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import { Button, Modal } from "@mui/material";

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
  height: "65px",
}));

export default function Layout({
  children,
  refState,
  setRefState,
  setRefStatenew,
  refStatenew,
}) {
  const [timeWarning, setTimeWarning] = React.useState(false);

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: { xs: "90%", sm: 400, md: 450 },
    bgcolor: "background.paper",
    boxShadow: 24,
    borderRadius: "12px",
    p: 3,
  };

  return (
    <>
      <Box sx={{ display: "flex" }}>
        <Sidebar
          setRefState={setRefState}
          refState={refState}
          setRefStatenew={setRefStatenew}
          refStatenew={refStatenew}
        />
        <Box
          component="main"
          sx={{ flexGrow: 1, p: 3 }}
          className="padding-set"
        >
          <DrawerHeader />
          {children}
        </Box>
      </Box>

      <Modal
        open={timeWarning}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <div style={{ textAlign: "center", marginBottom: "16px" }}>
            <WarningAmberIcon sx={{ fontSize: 50, color: "#f57c00", mb: 1 }} />
            <h2 style={{ margin: 0, fontWeight: 600 }}>
              Session Expiring Soon
            </h2>
          </div>
          <p
            style={{
              textAlign: "center",
              color: "#555",
              fontSize: "15px",
              marginBottom:
                window.location.pathname === "/orbit-intel-chat" ? "0px" : "20px",
            }}
          >
            Your session will expire in 5 minutes due to inactivity.
          </p>
          {window.location.pathname === "/orbit-intel-chat" ? (
            <p
              style={{
                textAlign: "center",
                color: "#555",
                fontSize: "15px",
                marginBottom: "20px",
              }}
            >
              Just send a message to keep the conversation going.
            </p>
          ) : null}
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              gap: "10px",
              flexWrap: "wrap",
            }}
          >
            <Button className="de_next" onClick={() => setTimeWarning(false)}>
              {window.location.pathname === "/orbit-intel-chat"
                ? "Continue Chatting"
                : "Close"}{" "}
            </Button>
          </div>
        </Box>
      </Modal>
    </>
  );
}
